import React, { useEffect, useState } from "react";
import "./GroupLoansListLoans.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography, CircularProgress } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansViewLateFees from "../GroupLoansViewLateFees/GroupLoansViewLateFees";
import GroupLoansViewPayments from "../GroupLoansViewPayments/GroupLoansViewPayments";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansListLoans = ({ selectedMember, setMembersListView, selectedMemberName }) => {
    const [loansArray, setLoansArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [loansListView, setLoansListView] = useState(null);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    
    useEffect(()=>{
        console.log("GroupLoansListLoans------------",selectedMember)
        getListOfLoans();
    },[selectedMember]);

    const getListOfLoans = async() => {
        try {
            const response = await commonRunQuery(290, selectedMember?.loangroupmemberloan?.userid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArr = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLoansArray(loansArr);
              console.log("getListOfLoans_response==========",loansArr);
            } else {
                setLoansArray([]);
            }
        } catch (error) {
            console.log("getListOfLoans_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Loan Id',
            getValue: (row) => row?.li?.loanid ?? ''
        },
        {
            label: 'Product Code',
            getValue: (row) => row?.li?.currcode  ?? ''
        },
        {
            label: 'Issued Amount',
            getValue: (row) => row?.li?.issuedamount ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Issued Date',
            getValue: (row) => row?.li?.issueddate ?? ''
        },
        {
            label: 'Loan Type',
            getValue: (row) => row?.lt?.loandesc ?? ''
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                loansListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        List Of Loans - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setMembersListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {loading ? (
                    <Box
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {
                            loansListView == null && <Box className="mt-4">
                                <GroupLoansTable
                                    data={loansArray} 
                                    columns={columns} 
                                    title="List of Loans" 
                                    formatRow={(row) => [
                                        row.id,
                                        row.record?.BorrowerName,
                                        row.name,
                                        row.balance,
                                        row.record?.DaysPastDue,
                                        row.record?.AmountDue
                                    ]} 
                                    viewMenu={true}
                                    handleMenuOpen={handleMenuOpen}
                                    downloads={false}
                                    // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                                />
                            </Box>
                        }
                    </>
                )
            }


            { loansListView == "viewPayments" && <GroupLoansViewPayments selectedLoan={selectedLoan} setLoansListView={setLoansListView} selectedMemberName={selectedMemberName} /> }
            { loansListView == "viewLateFees" && <GroupLoansViewLateFees selectedLoan={selectedLoan} setLoansListView={setLoansListView} selectedMemberName={selectedMemberName} /> }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setLoansListView('viewPayments');
                        handleMenuClose();
                    }}
                >
                    View Payments
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setLoansListView('viewLateFees');
                        handleMenuClose();
                    }}
                >
                    View Late Fees
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <div className="">
                <BaseDrawer
                    open={openDetailsDrawer}
                    handleClose={() => setOpenDetailsDrawer(false)}
                    height="75vh"
                    className="loanProductInfoDrawer"
                    overflow="auto"
                >
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        {/* Left Column */}
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Loan ID", value: selectedLoan?.li?.loanid },
                                                { label: "User ID", value: selectedLoan?.li?.userid },
                                                { label: "Issued Date", value: selectedLoan?.li?.issueddate },
                                                { label: "Currency Code", value: selectedLoan?.li?.currcode },
                                                { label: "External Ref No", value: selectedLoan?.li?.externalrefno },
                                                { label: "Loan Confirmed", value: selectedLoan?.li?.loanconfirmed === "1" ? "Yes" : "No" },
                                                { label: "Cancellation Reason", value: selectedLoan?.li?.cancellationreason || "N/A" },
                                                { label: "Cancellation Date", value: selectedLoan?.li?.cancellationdatetime || "N/A" },
                                                { label: "Loan Upgraded", value: selectedLoan?.li?.loanupgraded === "1" ? "Yes" : "No" },
                                                { label: "Loan Type", value: selectedLoan?.lt?.loandesc},
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        {/* Right Column */}
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Issued Amount", value: selectedLoan?.li?.issuedamount },
                                                { label: "Total Amount", value: selectedLoan?.li?.totalamount },
                                                { label: "Total Fees", value: selectedLoan?.li?.totalfees },
                                                { label: "Outstanding Principal", value: selectedLoan?.li?.outstandingprinciple },
                                                { label: "Outstanding Fees", value: selectedLoan?.li?.outstandingfees },
                                                { label: "Outstanding Principal & Fees", value: selectedLoan?.li?.outstandingprincipleandfees },
                                                { label: "Total Amount Applied", value: selectedLoan?.li?.totalamountapplied },
                                                { label: "Total Principal & Fees", value: selectedLoan?.li?.totalprincipleandfees },
                                                { label: "Tax Amount", value: selectedLoan?.li?.taxamount },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value ? Number(value).toLocaleString() : "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </BaseDrawer>
            </div>

            <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        {/* Left Column */}
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Loan ID", value: selectedLoan?.li?.loanid },
                                                { label: "User ID", value: selectedLoan?.li?.userid },
                                                { label: "Issued Date", value: selectedLoan?.li?.issueddate },
                                                { label: "Currency Code", value: selectedLoan?.li?.currcode },
                                                { label: "External Ref No", value: selectedLoan?.li?.externalrefno },
                                                { label: "Loan Confirmed", value: selectedLoan?.li?.loanconfirmed === "1" ? "Yes" : "No" },
                                                { label: "Cancellation Reason", value: selectedLoan?.li?.cancellationreason || "N/A" },
                                                { label: "Cancellation Date", value: selectedLoan?.li?.cancellationdatetime || "N/A" },
                                                { label: "Loan Upgraded", value: selectedLoan?.li?.loanupgraded === "1" ? "Yes" : "No" },
                                                { label: "Loan Type", value: selectedLoan?.lt?.loandesc},
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        {/* Right Column */}
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Issued Amount", value: selectedLoan?.li?.issuedamount },
                                                { label: "Total Amount", value: selectedLoan?.li?.totalamount },
                                                { label: "Total Fees", value: selectedLoan?.li?.totalfees },
                                                { label: "Outstanding Principal", value: selectedLoan?.li?.outstandingprinciple },
                                                { label: "Outstanding Fees", value: selectedLoan?.li?.outstandingfees },
                                                { label: "Outstanding Principal & Fees", value: selectedLoan?.li?.outstandingprincipleandfees },
                                                { label: "Total Amount Applied", value: selectedLoan?.li?.totalamountapplied },
                                                { label: "Total Principal & Fees", value: selectedLoan?.li?.totalprincipleandfees },
                                                { label: "Tax Amount", value: selectedLoan?.li?.taxamount },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value ? Number(value).toLocaleString() : "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            
        </Box>
    )

}

export default GroupLoansListLoans;
